export const LOCAL_STORAGE_KEY = {
  SAVE_TAB_VALUE_KEY: "ownerReportSharetabValue",
  FIRST_VIEW_KEY: "ownerReportShareFirstView",
  AI_PROOFREADING_SETTING_NEW_LABEL_HIDDEN: "ownerReportAiProofreadingSetting",
  AI_PROOFREADING_ALERT_SHOWN: "ai_proofreading_alert_shown"
};
